import { MouseEvent } from "react";

import styles from "./SignatureViewer.module.scss";

interface ISignatureViewerProps {
    signatureSource: string;
    onRemoveSignature?: (e: MouseEvent<HTMLSpanElement>) => void;
}

function SignatureViewer(props: ISignatureViewerProps): JSX.Element {
    return (
        <div className={styles.container}>
            {props.onRemoveSignature && (
                <span
                    onClick={e => props.onRemoveSignature(e)}
                    className={`fa fa-times hover-img ${styles.deletionIcon}`}
                />
            )}
            {props.signatureSource && (
                <img
                    onSelect={event => event.preventDefault()}
                    className={styles.signatureImg}
                    src={props.signatureSource}
                    alt="signature image"
                />
            )}
        </div>

    );
}

export { SignatureViewer };
